import Component from '../core/Component'
import { queries, CMS, IE } from '../core/config'
import enquire from 'enquire.js'
import Scroll from '../services/Scroll'
import { findDiffIndex } from '../utils/String'
import { queryAll, toggleClass } from '../utils/dom'
import anime from 'animejs'

export const defaults = {
    media: 'all'
}

export const STATES = {
    READY: 'is-ready'
}

export default class LayerScroller extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            layers: [],
            titles: [],
            texts: [],
            images: [],
            buttons: [],
            badge: null,
            content: null
        }

        this.limit = {
            min: 0,
            max: 0,
            mid: 0
        }

        this.isActive = true
        this.isScrolled = false

        this.enquireQuery = this.options.media in queries ? queries[this.options.media] : this.options.media
        this.enquireHandler = {
            match: ::this.attach,
            unmatch: ::this.detach,
            destroy: ::this.detach
        }

        this.titles = []
        this.texts = []
        this.images = []
    }

    prepare() {
        if (CMS || IE) {
            return
        }

        enquire.register(this.enquireQuery, this.enquireHandler)
    }

    destroy() {
        enquire.unregister(this.enquireQuery, this.enquireHandler)
    }

    attach() {
        Scroll.on('resize', this.handleResize)
        Scroll.on('scroll', this.handleScroll)

        this.ref.spacer = document.createElement('div')
        this.ref.spacer.classList.add('SectionSpacer-spacer')
        this.element.appendChild(this.ref.spacer)

        this.element.classList.add(STATES.READY)
        this.element.offsetWidth

        this.parse()

        this.resize()
    }

    detach() {
        Scroll.off('resize', this.handleResize)
        Scroll.off('scroll', this.handleScroll)

        if (this.ref.spacer) {
            this.ref.spacer.parentNode.removeChild(this.ref.spacer)
            this.ref.spacer = null
        }

        this.ref.content.removeAttribute('style')
        this.element.classList.remove(STATES.READY)


        this.titles.forEach(title => title.forEach(char => char.removeAttribute('style')))
        this.texts.forEach(text => text.forEach(item => item.element.removeAttribute('style')))

        this.ref.images.forEach(image => image.removeAttribute('style'))
        this.ref.buttons.forEach(image => image.removeAttribute('style'))
        this.ref.badge && this.ref.badge.removeAttribute('style')

        this.isActive = false
    }

    parse() {

        const titles = this.ref.titles.map(title => title.innerText.trim().replace(/\n/g, ' xxx '))
        const diffIndex = findDiffIndex(...titles)

        this.titles = this.ref.titles
            .map(element => {
                let text = element.innerText.trim().replace(/\n/g, ' xxx ')
                const sameText = text
                    .substring(0, diffIndex)
                    .split(' ')
                    .map(item => item === 'xxx' ? '<br>' : `<span class="Word">${item}</span>`)
                    .join(' ')

                element.innerHTML = sameText + text.substring(diffIndex)
                    .split(' ')
                    .map(word => word.trim() === 'xxx' ? '<br>' : `<span class="Word"><span class="Char" data-ref="char">${word}</span></span>`)
                    .join(' ')

                return element
            })
            .map(element => queryAll('[data-ref="char"]', element))
            // .map(list => list.slice(diffIndex))

        this.titles[0].forEach(char => char.style.transform = 'translateY(0%)')
        this.titles[1].forEach(char => char.style.transform = 'translateY(100%)')

        const height = Math.max(...this.ref.texts.map(element => element.scrollHeight))

        this.ref.texts.forEach(element => element.style.height = `${height}px`)

        this.texts = this.ref.texts
            .map(element => queryAll('p', element))
            .map(elements => elements.flatMap(element => {
                element.innerHTML = element.innerText
                    .trim()
                    .split(' ')
                    .map(word => `<span class="Word"><span class="Char" data-ref="char">${word}</span></span>`)
                    .join(' ')

                return queryAll('[data-ref="char"]', element)
                    .map(element => ({
                        element,
                        row: 0
                    }))
            }))

        this.images = this.ref.images.map(element => ({
            element,
            min: 0,
            max: 0,
            offset: 0
        }))

        this.texts[0].forEach(char => char.element.style.transform = 'translateY(0%)')
        this.texts[1].forEach(char => char.element.style.transform = 'translateY(100%)')

        this.ref.buttons[0].style.transform = 'translateY(0%)'
        this.ref.buttons[1].style.transform = 'translateY(100%)'

        this.ref.badge.style.transform = 'scale(1.1)'
        this.ref.badge.style.opacity = 0

        this.ref.layers[1].classList.add('is-transparent')

    }

    handleResize = event => {
        this.resize()
    }

    handleScroll = ({ offset }) => {
        this.render(offset.y)
    }

    render(scrollTop) {

        this.images.forEach(image => {
            if (scrollTop > image.min && scrollTop < image.max) {
                image.element.style.transform = `translateY(${image.min - scrollTop + image.offset}px)`
            }

            if (scrollTop < image.min) {
                image.element.style.transform = `translateY(${image.offset}px)`
            }

            if (scrollTop > image.max) {
                image.element.style.transform = `translateY(${image.min - image.max + image.offset}px)`
            }
        })

        if (scrollTop < this.limit.min || scrollTop > this.limit.max) {
            if (this.isActive) {
                this.isActive = false
            }
            return
        }

        this.isActive = true

        const offset = scrollTop - this.limit.min

        this.ref.content.style.transform = `translateY(${offset}px)`

        if (scrollTop > this.limit.mid && !this.isScrolled) {
            this.isScrolled = true
            this.getAnimate('down')()
        }

        if (scrollTop < this.limit.mid && this.isScrolled) {
            this.isScrolled = false
            this.getAnimate('up')()
        }

    }

    getAnimate(direction = 'down') {
        const up = direction === 'up'

        const title = anime.timeline()
        const text = anime.timeline()
        const button = anime.timeline()
        const badge = anime.timeline()

        if (up) {
            title
                .add({
                    targets: this.titles[1],
                    translateY: '100%',
                    duration: 200,
                    easing: 'easeInCirc',
                    delay: anime.stagger(20)
                })
                .add({
                    targets: this.titles[0],
                    translateY: '0%',
                    duration: 300,
                    easing: 'easeOutExpo',
                    delay: anime.stagger(20)
                })

            text
                .add({
                    targets: this.texts[1].map(item => item.element),
                    translateY: '100%',
                    duration: 200,
                    easing: 'easeInCirc',
                    delay: (element, index, length) => this.texts[1][index].row * 20
                })
                .add({
                    targets: this.texts[0].map(item => item.element),
                    translateY: '0%',
                    duration: 300,
                    easing: 'easeOutExpo',
                    delay: (element, index, length) => this.texts[0][index].row * 20
                })

            button
                .add({
                    targets: this.ref.buttons[1],
                    translateY: '100%',
                    duration: 200,
                    easing: 'easeInCirc'
                })
                .add({
                    targets: this.ref.buttons[0],
                    translateY: '0%',
                    duration: 300,
                    easing: 'easeOutExpo'
                })

            badge
                .add({
                    targets: this.ref.badge,
                    scale: 1.1,
                    opacity: 0,
                    duration: 400,
                    easing: 'easeOutCirc'
                })
        } else {
            title
                .add({
                    targets: this.titles[0],
                    translateY: '-100%',
                    duration: 200,
                    easing: 'easeInCirc',
                    delay: anime.stagger(20)
                })
                .add({
                    targets: this.titles[1],
                    translateY: '0%',
                    duration: 300,
                    easing: 'easeOutExpo',
                    delay: anime.stagger(20)
                })

            text
                .add({
                    targets: this.texts[0].map(item => item.element),
                    translateY: '-100%',
                    duration: 200,
                    easing: 'easeInCirc',
                    delay: (element, index, length) => this.texts[0][index].row * 20
                })
                .add({
                    targets: this.texts[1].map(item => item.element),
                    translateY: '0%',
                    duration: 300,
                    easing: 'easeOutExpo',
                    delay: (element, index, length) => this.texts[1][index].row * 20
                })

            button
                .add({
                    targets: this.ref.buttons[0],
                    translateY: '-100%',
                    duration: 200,
                    easing: 'easeInCirc'
                })
                .add({
                    targets: this.ref.buttons[1],
                    translateY: '0%',
                    duration: 300,
                    easing: 'easeOutExpo'
                })

            badge
                .add({
                    targets: this.ref.badge,
                    scale: 1,
                    opacity: 1,
                    duration: 300,
                    easing: 'easeInQuint'
                })
        }

        return () => {
            toggleClass(this.ref.layers[0], 'is-transparent', direction === 'down')
            toggleClass(this.ref.layers[1], 'is-transparent', direction === 'up')
            title.play()
            text.play()
            button.play()
            badge.play()
        }
    }

    resize() {
        this.layerDimensions = {
            height: this.ref.layers.reduce((sum, element) => sum + element.offsetHeight, 0)
        }

        this.ref.content.style.height = `${this.layerDimensions.height}px`

        const elementBox = this.element.getBoundingClientRect()

        const windowHeight = window.innerHeight

        const scrollOffset = Scroll.getScroll()

        this.limit.min = scrollOffset.y + elementBox.top
        this.limit.max = this.limit.min + this.layerDimensions.height - windowHeight
        this.limit.mid = this.limit.min + (this.limit.max - this.limit.min)/2

        this.ref.spacer.style.height = `${this.layerDimensions.height}px`

        this.texts.forEach(list => {
            let row = -1
            let top = 0

            list.forEach(item => {
                const offset = item.element.offsetTop

                if (offset !== top) {
                    row++
                    top = offset
                }

                item.row = row
            })
        })

        let offset = 0
        this.images.forEach((item, index) => {
            if (index > 0) {
                offset += this.ref.layers[index - 1].offsetHeight
            }

            item.offset = offset

            const layerBox = this.ref.layers[index].getBoundingClientRect()
            const box = item.element.parentNode.getBoundingClientRect()

            item.min = box.top + scrollOffset.y + box.height/2 - windowHeight/2
            item.max = index === 0 ? item.min + this.layerDimensions.height : item.min + offset
        })

        //sync sirek vymenovanych slov
        if (this.titles && this.titles.length) {
            this.titles[0].forEach((char, index) => {
                if (this.titles[1] && this.titles[1][index]) {
                    const char2 = this.titles[1][index]
                    char.style.width = ''
                    char2.style.width = ''
                    const widths = [char2.offsetWidth, char.offsetWidth]
                    if (Math.min(...widths) <= 0) {
                        return
                    }
                    const width = Math.max(...widths)
                    char.style.width = `${width}px`
                    char2.style.width = `${width}px`
                }
            })
        }

        this.render(scrollOffset.y)
    }

}